import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ReactComponent as Branches } from "../../../../assets/svg/branch-location.svg";
import { ReactComponent as Location } from "../../../../assets/svg/location.svg";
import { IconWithText } from "../IconWithText";

const useStyles = makeStyles(() => ({
  branchesContainer: {
    marginTop: 16,
    border: "1px solid #C5C5C5",
    borderRadius: 15,
    padding: "16px 32px 16px 32px",
  },
  content: {
    display: "flex",
    columnGap: 8,
    alignItems: "center",
    "& + &": {
      marginTop: 11,
    },
  },
  name: {
    fontSize: 17,
    color: "#858997",
    wordBreak: "break-word",
  },
}));

interface BranchesShowProps {
  branches: string[];
}

export const BranchesWidget: FC<BranchesShowProps> = ({ branches }) => {
  const classes = useStyles();

  return (
    <div>
      <IconWithText Icon={Branches} title="Branches" />
      <div className={classes.branchesContainer}>
        {branches.map((branch) => (
          <div key={branch} className={classes.content}>
            <Location />
            <div className={classes.name}>{branch}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
